module.exports = __webpack_public_path__ + "img/play.df68babf.png";